export default "__VITE_ASSET__DYzeUD7C__"